import { Subject } from "rxjs";
import { ExternalMAMServiceProvider } from "./external-mam-service-provider";
import { ExternalMAMGatewayProvider } from "./external-mam-gateway-provider";
import { ExternalMAMGatewayProviderInfo } from "./external-mam-gateway-provider-info";
import ExternalMAMMetadataItem from "./external-mam-metadata-item";
import { ExternalMAMSearchRequest } from "./external-mam-search-request";
import { ExternalMAMImportRequest } from "./external-mam-import-request";
import { ExternalMAMUpdateItemMetadataRequest } from "./external-mam-update-item-metadata-request";
export abstract class IExternalMAMRepository {
  updated: Subject<ExternalMAMGatewayProvider>;
  created: Subject<ExternalMAMGatewayProvider>;
  deleted: Subject<ExternalMAMGatewayProvider>;
  abstract create(gateway: ExternalMAMGatewayProvider): Promise<string>;
  abstract update(gateway: ExternalMAMGatewayProvider): Promise<boolean>;
  abstract loadServiceProviders(): Promise<Array<ExternalMAMServiceProvider>>;
  abstract loadGatewayProviders(): Promise<
    Array<ExternalMAMGatewayProviderInfo>
  >;
  abstract getServiceProviderById(
    id: number,
  ): Promise<ExternalMAMServiceProvider>;
  abstract getServiceProviderByName(
    name: string,
  ): Promise<ExternalMAMServiceProvider>;
  abstract getGatewayProviderById(
    id: string,
  ): Promise<[ExternalMAMGatewayProvider, Array<ExternalMAMMetadataItem>]>;
  abstract testConnection(
    gateway: ExternalMAMGatewayProvider,
  ): Promise<boolean>;
  abstract getMetadata(
    provider: ExternalMAMGatewayProvider,
  ): Promise<Array<ExternalMAMMetadataItem>>;
  abstract getSearchResults(
    request: ExternalMAMSearchRequest,
  ): Promise<[number, Array<any>]>;
  abstract startImport(request: ExternalMAMImportRequest): Promise<string>;
  abstract updateItemMetadata(
    request: ExternalMAMUpdateItemMetadataRequest,
  ): Promise<string>;
}
